import { formatDisplay } from 'helpers/formatHelper';

const getDefaultMaxValue = (type: DataTypesT) =>
    type === 'fraction' ? 100 : 0;

export const getGaugeMaxValue = (
    settingsMaxValue: number | undefined,
    metricMaxValue: number | 'unknown' | undefined,
    yType: DataTypesT,
): number => {
    // La valeur maximale de la gauge est celle de la métrique fournie si celle-ci est correctement définie
    if (metricMaxValue !== undefined && typeof metricMaxValue === 'number')
        return metricMaxValue;
    // Le backend peut renvoyer "unknown", on set à 0 pour ce cas de bord.
    if (metricMaxValue === 'unknown') return 0;
    const maxValue = settingsMaxValue
        ? settingsMaxValue
        : getDefaultMaxValue(yType);
    if (yType === 'fraction') return maxValue / 100;
    return maxValue;
};

export const getGaugeMinValue = (
    settingsMinValue: number | undefined,
    yType: DataTypesT,
): number => {
    const minValue = settingsMinValue ? settingsMinValue : 0;
    if (yType === 'fraction') return minValue / 100;
    return minValue;
};

export const isNumberBroken = (value: number | 'unknown') =>
    Number.isNaN(value);

export const addPercentageToNumberText = (
    filledRatioRaw: number,
    yType: DataTypesT,
    minValue: number,
    maxValue: number,
    numberText?: string,
) => {
    let newNumberText: string;
    // If type if fraction, then we do not need to add it
    if (yType !== 'fraction') {
        if (minValue !== maxValue && !isNumberBroken(filledRatioRaw)) {
            newNumberText = `(${formatDisplay(filledRatioRaw, 'fraction')})`;
        } else {
            newNumberText = '(- %)';
        }

        if (numberText) {
            newNumberText = `${newNumberText}\n${numberText}`;
        }
    } else {
        newNumberText = numberText || '';
    }
    return newNumberText;
};
